export enum CategoryFilterEnum {
	PENDING = 'PARCIALMENTE LIBERADO',
	WAITING = 'AGUARDANDO',
	RELEASED = 'LIBERADO',
	ALL = 'ALL',
}

export type ExamResultStatus = Exclude<CategoryFilterEnum, CategoryFilterEnum.ALL>;

export enum ExamResultTypeEnum {
	LABORATORY = 'LABORATÓRIAL',
	VARIED = 'LABORATÓRIAL E IMAGEM',
	IMAGE = 'IMAGEM',
	ALL = 'ALL',
}

export type ExamResultsType = Exclude<ExamResultTypeEnum, ExamResultTypeEnum.ALL>;

export interface IExamReport {
	urlPacsmobile: string | null;
	dtLaudo: string | null;
	cdProcedimento: string;
	dsProcedimento: string;
	cdAtendimento: number;
	cdOcorrencia: number;
	flTipoExame: string;
	dtExame: string;
	flOrigem: string;
	cdOrdem: number;
}

export interface IExamResult {
	dsTipoExame: ExamResultsType;
	cdPrestadorJuridico: number;
	dsPrestadorJuridico: string;
	dsStatus: ExamResultStatus;
	laudos: IExamReport[];
	dtPedido: string;
	nuPedido: number;
	nmSolicitante: string;
}

export type GetExamResultsParams = {
	dt_referencia?: string;
	cd_ponto_entrada?: string;
	cdAtendimento?: number;
	signal?: AbortSignal;
};

export type GetExamResultsModel = IExamResult[];

export interface GetExamResults {
	get: (params: GetExamResultsParams) => Promise<GetExamResultsModel>;
}
